import React from 'react';
import Chart from 'react-apexcharts';

const HighestFailureAPIs = ({ apis }) => {
    // Filter APIs with minimum requests to avoid skewing and sort by error rate
    const failedApis = [...apis]
        .filter(api => api.calls >= 5 && api.errorRate > 0)
        .sort((a, b) => b.errorRate - a.errorRate)
        .slice(0, 10);

    const options = {
        chart: { type: 'bar', toolbar: { show: false } },
        plotOptions: {
            bar: { horizontal: true, borderRadius: 4, colors: { ranges: [{ from: 0, to: 100, color: '#e74c3c' }] } }
        },
        xaxis: { categories: failedApis.map(api => api.path), labels: { formatter: (val) => val + '%' }, max: 100 },
        dataLabels: { enabled: true, formatter: (val) => val + '%' }
    };

    const series = [{ name: 'Failure Rate %', data: failedApis.map(api => api.errorRate) }];

    return (
        <div className="chart-card">
            <h3>Highest Failure Rate APIs</h3>
            {failedApis.length > 0 ? (
                <Chart options={options} series={series} type="bar" height={350} />
            ) : (
                <div style={{ padding: '40px 0', textAlign: 'center', color: '#7f8c8d' }}>No significant failures detected.</div>
            )}
        </div>
    );
};

export default HighestFailureAPIs;
